import { Box, Flex, Image } from '@chakra-ui/react';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';

import ShoppingBagIcon from 'Asset/icon/shopping-bag.svg';
import BadgeEcomerce from 'Component/badge-ecommerce';
import EmptyState from 'Component/empty-state';
import { Condition, Iteration } from 'Component/others';
import useGetPromoBrief from 'Domain/productivity-host/useGetPromoBrief';
import Accordion from 'UiKit/accordion';
import Badge from 'UiKit/badge';
import { TextMedium, TextRegular } from 'UiKit/typography';
import { useTranslation } from 'react-i18next';

import PromoContentSkeleton from './skeleton';
import styles from './styles.module.css';

const PromoPanel = ({ data }) => {
  return (
    <Flex gap={'8px'} alignItems={'center'}>
      <Image src={data?.logo} width={'16px'} height={'16px'} fallbackSrc={ShoppingBagIcon} alt={`${data?.name}-logo`} />
      <TextMedium>{data?.name}</TextMedium>
    </Flex>
  );
};

const PromoChildren = ({ data }) => {
  const navigate = useNavigate();

  const handlePromoClick = (promo) => {
    navigate('/host/stock-promo', { state: { selectedDetailPromo: promo } });
  };

  return (
    <Flex flexDirection={'column'} gap={'8px'}>
      <Iteration
        items={data}
        render={(promo) => {
          const badgeVariant = {
            Aktif: 'success',
            'Tidak Aktif': 'error',
          };
          return (
            <Box
              className={styles['promo__box--children-item']}
              onClick={() => handlePromoClick(promo)}
              cursor="pointer"
              _hover={{ backgroundColor: 'var(--color-semantic-outline-hover)' }}
              transition="background-color 0.2s ease"
            >
              <Flex alignItems={'center'} gap={'8px'}>
                <Badge variant={badgeVariant[promo?.status]} children={promo?.status} size="sm" />
                <BadgeEcomerce accountName={promo?.storeName} ecommerce={promo?.ecommerce} />
              </Flex>
              <TextMedium className={styles['promo__text--promo-name']}>{promo?.name}</TextMedium>
              <TextRegular className={styles['promo__text--promo-count-period']}>{promo?.productCountAndPeriod}</TextRegular>
            </Box>
          );
        }}
      />
    </Flex>
  );
};

const PromoContent = () => {
  const { t } = useTranslation('empty-state');
  const { data, isLoading } = useGetPromoBrief();

  if (isLoading) return <PromoContentSkeleton />;

  return (
    <Box className={styles['content__container']}>
      <Condition
        statement={!isEmpty(data)}
        fallback={
          <Box flex={1}>
            <EmptyState
              title={t('specific_item.title', { itemName: 'Promo' })}
              description={t('specific_item.description', { itemName: 'Promo' })}
              background="var(--color-semantic-white)"
              height="calc(100dvh - 180px)"
            />
          </Box>
        }
      >
        <Iteration
          items={data}
          render={(item) => {
            return <Accordion header={<PromoPanel data={item?.ecommerce} />} children={<PromoChildren data={item?.items} />} />;
          }}
        />
      </Condition>
    </Box>
  );
};

export default PromoContent;
